import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'

const fetchTransferProduct = async (
  userUuid: string,
  productId: number,
  recipientUserUuid: string,
  cardCode?: string
) => {
  const response = await fetch(
    `${BASE_API_URL}/admin/api/v2/users/${userUuid}/user_linq_products/${productId}/transfer`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({
        recipient_user_uuid: recipientUserUuid,
        card_code: cardCode,
      }),
    }
  )
  handleErrors(response)
}

const useMutationTransferProduct = ({ userUUID }: { userUUID: string }) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({
      productId,
      recipientUserUuid,
      cardCode,
    }: {
      productId: number
      recipientUserUuid: string
      cardCode?: string
    }) => {
      return fetchTransferProduct(
        userUUID,
        productId,
        recipientUserUuid,
        cardCode
      )
    },
    {
      onSuccess: () => {
        toast('Product successfully transferred', { icon: `👍` })
      },
      onError: (e) => {
        console.error(e)
        alert(
          'Uh oh! There was an error! Check the console. Take a screenshot and send to engineers.'
        )
      },
      onSettled: () => {
        queryClient.invalidateQueries(`admin/api/v1/users/${userUUID}`)
      },
    }
  )
}

export default useMutationTransferProduct
